"use client";

import React from "react";
import styles from '../css/components/FileInput.module.css'; 

const FileInput = ({
  label,
  name,
  id,
  value,
  onChange,
  accept,
  className = "",
  wide = false,
  existingUrl,
}) => {

  // Debug: Log the value prop to check for multiple files or unexpected data
  console.log("FileInput value:", value);

  return (
    <div className={`${styles.fileInput} ${wide ? styles.fileInputWide : ""} ${className}`}>
      <label htmlFor={id} className={styles.fileLabel}>
        {label}
      </label>
      <div className={styles.fileInputWrapper}>
        <label htmlFor={id} className={styles.customFileButton}>
          Choose File
        </label>
        <input
          type="file"
          id={id}
          name={name}
          onChange={onChange}
          accept={accept}
          className={styles.hiddenFileInput}
        />
        <span className={styles.fileNameDisplay}>
          {value && value.name ? (
            value.name
          ) : existingUrl ? (
            <a
              href={existingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.fileLink}
            >
              View existing document
            </a>
          ) : (
            "No file chosen"
          )}
        </span>
      </div>
    </div>
  );
};

export default FileInput;